import './select-hour.css'
import React from 'react'
import { HiChevronLeft } from "react-icons/hi";
import { HiChevronRight } from "react-icons/hi";
import { HiOutlineCalendar } from "react-icons/hi";

const SelectHour = ({Action, Hour}) => {
    return (
        <div className='container-hour' onClick={Action}>
            <span className='app-little-title hour'>{Hour}</span>
        </div>
    )
}

export default SelectHour